<script setup lang="ts">
import { ref } from "vue";
import MainBreadcrumbs from "@/ui/components/header/MainBreadcrumbs.vue";
import Card from "@/ui/components/cards/Card.vue";
import { RouteGuards } from "@/router/guards";
import { useBaseStore } from "@/stores/base";

const store = useBaseStore();

type TabsType = {
	itemId: string;
	translationKey: string;
	icon: string;
	to: string;
};

const tabs: TabsType[] = [
	{
		itemId: "annotations",
		translationKey: "navigation.items.annotations",
		icon: "fa-comment",
		to: "/annotations/annotations",
	},
	{
		itemId: "preset-filters",
		translationKey: "annotations.categories",
		icon: "fa-tags",
		to: "/annotations/categories",
	},
];

const breadcrumbs = [
	{
		title: "Annotations",
		disabled: true,
		to: "/annotations",
	},
];

const activeTab = ref(null);
</script>

<template>
	<div>
		<main-breadcrumbs :breadcrumbs="breadcrumbs" />
		<v-tabs v-model="activeTab" class="rounded-md">
			<v-tab
				v-for="tab in tabs"
				v-show="
					RouteGuards.hasPermissions({
						to: RouteGuards.getRouteByPath(tab.to),
						store,
					})
				"
				:value="tab.itemId"
				color="primary"
				:to="tab.to"
			>
				<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
				<div class="tab-text">
					{{ $t(tab.translationKey) }}
				</div>
			</v-tab>
		</v-tabs>
		<v-divider />

		<router-view />
	</div>
</template>

<style scoped lang="scss"></style>
